'use client';

import Link from 'next/link';

export function Footer() {
  return (
    <footer className='py-6 md:py-10 bg-sidebar'>
      <div className='container'>
        <div className='relative flex flex-col items-center justify-center text-[0.875rem]'>
          <nav className='w-full'>
            <ul className='list-none flex flex-wrap justify-center gap-3 md:gap-5 font-[600]'>
              <li>
                <Link
                  href='/about-us'
                  title='About ClovisClassics.com'
                  className='hover:text-primary duration-300 transition-all py-1 block'
                >
                  About ClovisClassics.com
                </Link>
              </li>
              <li>
                <Link
                  href='/help-center'
                  title='Help Center'
                  className='hover:text-primary duration-300 transition-all py-1 block'
                >
                  Help Center
                </Link>
              </li>
              <li>
                <Link
                  href='/contact-us'
                  title='Contact Us'
                  className='hover:text-primary duration-300 transition-all py-1 block'
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  href='/privacy-policy'
                  title='Privacy Policy'
                  className='hover:text-primary duration-300 transition-all py-1 block'
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href='/terms-and-conditions'
                  title='Terms & Conditions'
                  className='hover:text-primary duration-300 transition-all py-1 block'
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </nav>
          <div
            className='relative mt-5 mb-2 lg:mt-0 lg:mb-0 lg:absolute top-0 right-0 flex items-center gap-2
          md:gap-4'
          >
            <Link
              href='https://www.facebook.com/ClovisClassics'
              target='_blank'
              className='hover:[&_img]:opacity-50'
            >
              <img src='/images/common/ic-facebook.png' alt='' className='duration-300 transition-all' />
            </Link>
            <Link href='https://www.tiktok.com/' target='_blank' className='hover:[&_img]:opacity-50'>
              <img src='/images/common/ic-tiktok.png' alt='' className='duration-300 transition-all' />
            </Link>
            <Link
              href='https://www.instagram.com/clovisclassics/'
              target='_blank'
              className='hover:[&_img]:opacity-50'
            >
              <img src='/images/common/ic-instagram.png' alt='' className='duration-300 transition-all w-6 md:w-auto' />
            </Link>
            <Link href='https://x.com/' target='_blank' className='hover:[&_img]:opacity-50'>
              <img src='/images/common/ic-x.png' alt='' className='duration-300 transition-all w-6 md:w-auto' />
            </Link>
          </div>
          <div className='power mt-4 text-center'>
            Clovis Classics © {new Date().getFullYear()} All rights reserved
          </div>
        </div>
      </div>
    </footer>
  );
}
